import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useBoxConsumableActions = (memberId: string) => {
  const { boxPurchasesApi } = useServicesContext()
  const queryClient = useQueryClient()

  // Credit purchase
  const { mutateAsync: creditPurchase, isPending: isCreditPurchasePending } = useMutation({
    mutationFn: async ({ purchaseId, newCredits }: { purchaseId: string; newCredits: number }) => {
      return await boxPurchasesApi.creditPurchase(memberId, purchaseId, newCredits)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["boxPurchases", memberId],
      })
      queryClient.invalidateQueries({
        queryKey: ["boxMember", memberId],
      })
      queryClient.invalidateQueries({
        queryKey: ["boxMembers"],
      })
    },
  })

  // Remove purchase
  const { mutateAsync: deletePurchase, isPending: isDeletePurchasePending } = useMutation({
    mutationFn: async (purchaseId: string) => {
      return await boxPurchasesApi.deletePurchase(memberId, purchaseId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["boxPurchases", memberId],
      })
      queryClient.invalidateQueries({
        queryKey: ["boxMember", memberId],
      })
      queryClient.invalidateQueries({
        queryKey: ["boxMembers"],
      })
    },
  })

  return {
    creditPurchase,
    isCreditPurchasePending,
    deletePurchase,
    isDeletePurchasePending,
  }
}
